<template>
        <v-container>
            <v-row class="contentRow">
                <v-col>
                    <h1 class="mb-2">Internal Comments for Transaction
                            <router-link :to="`/trace/transactions/${transactionID}`"> #{{transactionID}}</router-link>
                    </h1>
                </v-col>
            </v-row>
            <v-form ref="form" v-model="valid"  lazy-validation>
            <v-row class="contentRow">
                <v-col cols="12">
                    <v-col>
                        <h3 class="mb-2">Submit Comment</h3>
                        <span>Enter message and color for comments.</span>
                    </v-col>
                </v-col>
                <v-col cols="4">
                    <v-textarea
                            label="Comment"
                            v-model="commentValues.message"
                            placeholder="Comment"
                            :rules="[v => !!v || 'Comment is required']"
                            outlined
                            rows="1"
                            dense
                    >
                    </v-textarea>
                </v-col>
                <v-col cols="4">
                    <v-select
                            label="Comment Type"
                            v-model="commentValues.type"
                            placeholder="Comment Type"
                            :rules="[v => !!v || 'Comment Type is required']"
                            outlined
                            dense
                            :items="commentTypes"
                    >
                    </v-select>
                </v-col>
                <v-col cols="4">
                    <v-btn color="primary"  align="center" class="mt-0 ml-5" @click="addComment" :disabled="!valid" >
                       Submit Comment
                    </v-btn>
                </v-col>

            </v-row>
            </v-form>
            <v-row class="contentRow" align="center">
                <v-col>
                    <v-card color="primary">
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="white--text">Internal Comments</h3>
                        </v-card-title>
                        <v-data-table
                                :loading="comments.loading"
                                theme--
                                light
                                :headers="headers"
                                :items="comments.data"
                                :items-per-page="comments.limit"
                                :server-items-length="comments.total"
                                :options.sync="comments.options"
                                class="light table mx-4 assessed-table"
                                :footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.type="{ item }"  >
                                <v-chip
                                        v-if="item.type==='note'"
                                        color="success"
                                        label
                                        text-color="white"
                                        small
                                >
                                    <v-icon left small>
                                        fas fa-sticky-note
                                    </v-icon>
                                  Note
                                </v-chip>
                                <v-chip
                                        v-if="item.type==='issue'"
                                        color="error"
                                        label
                                        text-color="white"
                                        small
                                >
                                    <v-icon left small>
                                        fas fa-exclamation
                                    </v-icon>
                                    Issue
                                </v-chip>
                            </template>
                            <template v-slot:item.message="{ item }">
                                <router-link :to="`/trace/transactions/${item.transactionID}/comments/${item.id}`">{{item.message}}</router-link>
                            </template>
                            <template v-slot:item.currentStatus="{ item }"  >
                                <v-chip
                                        v-if="item.currentStatus===0"

                                        label
                                        text-color="black"
                                        small
                                >
                                    <v-icon left small>
                                        fas fa-ellipsis-h
                                    </v-icon>
                                    Open
                                </v-chip>
                                <v-chip
                                        v-if="item.currentStatus===1"
                                        color="primary"
                                        label
                                        text-color="white"
                                        small
                                >
                                    <v-icon left small>
                                        fas fa-check-circle
                                    </v-icon>
                                    Closed
                                </v-chip>
                            </template>
                        </v-data-table>
                          <br />
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
</template>


<script>
import CommentsAPI from "../../api/trace/comments"
import LoadingState from "../../consts/LoadingState"
export default {
	name: "TransactionCommentsView",
	data() {
		return {
			valid:true,
			transactionID:location.pathname?.split("/")?.reverse()?.[1],
			commentValues:{
				message:null,
				type: null
			},
			commentTypes:["Note","Issue" ],
			comments:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				loading:true,
				options: {},
			},
			headers:[
				{
					text: "Type",
					align: "start",
					sortable: false,
					value: "type",
					class: "secondary--text"
				},
				{
					text: "Message",
					value: "message",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Opened By",
					value: "createdBy",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Status",
					value: "currentStatus",
					sortable: false,
					class: "secondary--text"
				}
			]
		}
	},
	mounted() {
		if(this.transactionID){
			this.getComments()
		}
	},
	watch:{
		"comments.options": {
			handler () {
				//if user select all
				if (this.comments.options.itemsPerPage===-1){
					this.comments.options.itemsPerPage=this.comments.total
				}
				this.comments.offset=(this.comments.options?.page-1) * this.comments.options?.itemsPerPage
				this.comments.limit=this.comments.options?.itemsPerPage
				this.getComments()
			},
			deep: true,
		},
	},
	methods: {
		addComment(){
			if(this.$refs.form.validate()){
				CommentsAPI.addComment(this.transactionID,{...this.commentValues})
					.then(() => {
						this.getComments()
						this.resetForm()
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
							"Comment was successfully added!",
							{ root: true }
						)
					})
					.catch(reason => {
						this.recentOptions.loading=false
						this.$store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							reason,
							{ root: true }
						)
					})

			}
		},
		getComments(){
			this.comments.loading=true
			CommentsAPI.getComments(this.transactionID,this.comments.limit,this.comments.offset)
				.then(data => {
					this.comments.total=data?.metadata?.pagination?.totalRecords
					this.comments.data=data?.data
					this.comments.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.comments.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		resetForm() {
			this.$refs.form.reset()
		},
	}
}
</script>